
import React from 'react';
import { Class } from '@/types/classTypes';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ScheduleForm } from './ScheduleForm';
import { useScheduleCreation } from '@/hooks/useScheduleCreation';

interface AddScheduleDialogProps {
  open: boolean;
  onClose: () => void;
  classId: string;
  organizationId: string;
  onScheduleAdded?: () => void;
  initialClassId?: string | null;
  classes?: Class[];
}

const AddScheduleDialog: React.FC<AddScheduleDialogProps> = ({
  open,
  onClose,
  classId,
  organizationId,
  onScheduleAdded,
  initialClassId = null,
  classes = [],
}) => {
  console.log("🏢 AddScheduleDialog props:", { organizationId, classId, initialClassId, classes });

  const {
    selectedClassId,
    setSelectedClassId,
    dayOfWeek,
    setDayOfWeek,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    addScheduleMutation,
    handleAddSchedule,
  } = useScheduleCreation({
    initialClassId,
    classId,
    organizationId,
    onScheduleAdded,
    onClose
  });

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Add Schedule</DialogTitle>
          <DialogDescription>
            Create a new schedule for this class
          </DialogDescription>
        </DialogHeader>

        <ScheduleForm
          dayOfWeek={dayOfWeek}
          setDayOfWeek={setDayOfWeek}
          startTime={startTime}
          setStartTime={setStartTime}
          endTime={endTime}
          setEndTime={setEndTime}
          selectedClassId={selectedClassId}
          setSelectedClassId={setSelectedClassId}
          classes={classes}
        />

        <DialogFooter>
          <Button type="button" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button 
            type="submit" 
            onClick={handleAddSchedule} 
            disabled={addScheduleMutation.isPending}
          >
            {addScheduleMutation.isPending ? 'Creating...' : 'Create Schedule'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddScheduleDialog;
